import axios from "axios";
import store from "@/store";
import { withClientHeaders } from "@/utils/clientHeaders";
import { handleStandardError } from "@/utils/standardErrorHandler";

// counsel-api 전용 인스턴스 (certilife 관리자 JWT를 counsel-api 가 그대로 검증한다)
const counselApiInstance = axios.create({
  baseURL: process.env.VUE_APP_COUNSEL_API_URL,
});

counselApiInstance.interceptors.request.use(
  (config) => {
    // 글로벌 로딩은 config에서 명시적으로 요청한 경우에만 활성화
    if (config.showGlobalLoading !== false) {
      store.commit("setIsLoading", true);
    }
    withClientHeaders(config);

    if (localStorage.getItem("accessTokenCerti")) {
      config.headers.Authorization = `Bearer ${localStorage.getItem("accessTokenCerti")}`;
    }
    return config;
  },
  (error) => {
    store.commit("setIsLoading", false);
    return Promise.reject(error);
  }
);

let isTokenRefreshing = false;
let failedRequestsQueue = [];

counselApiInstance.interceptors.response.use(
  (response) => {
    if (response.config.showGlobalLoading !== false) {
      store.commit("setIsLoading", false);
    }
    return response;
  },
  async (error) => {
    if (error.config && error.config.showGlobalLoading !== false) {
      store.commit("setIsLoading", false);
    }
    const originalRequest = error.config;

    // 새 계약 오류 코드(ACCOUNT_INACTIVE·OPERATOR_ACTING_DENIED·PERMISSION_DENIED 등): 알림 한 번 뒤 실패 — 토큰 갱신하지 않음(W6 E2)
    if (await handleStandardError(error, { notify: originalRequest?.showErrorNotice !== false })) return Promise.reject(error);

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (!isTokenRefreshing) {
        isTokenRefreshing = true;
        await store.dispatch("requestAccessToken");
        isTokenRefreshing = false;

        failedRequestsQueue.forEach((queueItem) => {
          queueItem.resolve(counselApiInstance(queueItem.originalRequest));
        });
        failedRequestsQueue = [];

        originalRequest._retry = true;
        originalRequest.headers.Authorization = `Bearer ${localStorage.getItem("accessTokenCerti")}`;
        return counselApiInstance(originalRequest);
      } else {
        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({
            resolve,
            reject,
            originalRequest,
          });
        });
      }
    }
    return Promise.reject(error);
  }
);

export default counselApiInstance;
